import Api from '../Api'

export async function updateNftOverview(name: string, updates: any) {
  const response = await Api.post(
    `/auth/cms/edit_nft_overview?name=${name}`,
    updates
  )
  return response.data
}
